module.exports = __webpack_public_path__ + "components/resort-finder/static/snow-finder-e2cbe89cddc026b19708fb3f15c0a8e3.svg";